// Cusomtom text, width, height and keep all behiver
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Avatar, Box, Stack, Typography, SvgIcon } from '@mui/material';

export const FileDropzone = (props) => {
  const { caption, files = [], maxFiles, ...other } = props;
  const { getRootProps, getInputProps, isDragActive } = useDropzone(other);

  return (
    <Box
      sx={{
        width: '100%', // Set a specific width
        alignItems: 'center',
        border: 1,
        borderRadius: 1,
        borderStyle: 'dashed',
        borderColor: 'lightgray',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        outline: 'none',
        p: 2,
        ...(isDragActive && {
          backgroundColor: 'action.active',
          opacity: 0.5,
        }),
        '&:hover': {
          backgroundColor: 'action.hover',
          cursor: 'pointer',
          opacity: 0.5,
        },
      }}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <Stack alignItems="center" direction="row" spacing={2}>
        <Avatar
          sx={{
            height: 64,
            width: 64,
          }}
        >
          <SvgIcon>
            <FileUploadOutlinedIcon />
          </SvgIcon>
        </Avatar>
        <Stack spacing={1}>
          <Typography
            sx={{
              '& span': {
                textDecoration: 'underline',
              },
            }}
            variant="contained"
          >
            {/* <span>Click to upload</span> or drag and drop */}
            <span>Nhấp để tải lên</span> hoặc kéo và thả ({files.length}/
            {maxFiles})
          </Typography>
          {caption && (
            <Typography color="text.secondary" variant="body2">
              {caption}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

FileDropzone.propTypes = {
  caption: PropTypes.string,
  files: PropTypes.array,
  onRemove: PropTypes.func,
  onRemoveAll: PropTypes.func,
  onUpload: PropTypes.func,
  // From Dropzone
  accept: PropTypes.objectOf(
    PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  ),
  disabled: PropTypes.bool,
  getFilesFromEvent: PropTypes.func,
  maxFiles: PropTypes.number,
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
  noClick: PropTypes.bool,
  noDrag: PropTypes.bool,
  noDragEventsBubbling: PropTypes.bool,
  noKeyboard: PropTypes.bool,
  onDrop: PropTypes.func,
  onDropAccepted: PropTypes.func,
  onDropRejected: PropTypes.func,
  onFileDialogCancel: PropTypes.func,
  preventDropOnDocument: PropTypes.bool,
};
